module.exports = __webpack_public_path__ + "img/cambodia-bg.e365a6ce.webp";